module.exports = __webpack_public_path__ + "static/img/img05.1835e59.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv019/img05.gif
// module id = vGVJ
// module chunks = 0